import { vslApi } from '@/api';

export default Object.freeze({
  fetchMyContainerDeliveryOrderList(params) {
    return vslApi.get(`/v1/public-ebookings/my-container-delivery-orders`, {
      params,
    });
  },
});
